import { IconCheckmark } from 'components/icons'

interface UserPremiumFeatureComponentProps {
    features: string[]
}

const UserPremiumFeatureComponent = ({ features }: UserPremiumFeatureComponentProps) => {
    return (
        <div className='grid md:grid-cols-2 rounded-md md:gap-4 lg:gap-x-3'>
            {features.map((item, index) => (
                <div key={index} className='flex mt-2 gap-x-2 items-center'>
                    <div className='relative bg-secondary p-2 rounded-full'>
                        <IconCheckmark className='size-4' />
                    </div>
                    <div className='font-medium'>{item}</div>
                </div>
            ))}
        </div>
    )
}

export default UserPremiumFeatureComponent
